export const FILE_BASE_URL =
  "https://swmp2devapi.vmaxtechservices.life/swmp2images/";

// // // //Dotnet Base
// export const API_BASE_URL1 ="https://swmp2devapi.vmaxtechservices.help/v1/";
// export const API_BASE_URL3 ="https://swmp2devapi.vmaxtechservices.help/v2/";

// old production URL
// export const API_BASE_URL1 = "https://hydapi.swachhcity.com/v1/";
// export const API_BASE_URL3 = "https://hydapi.swachhcity.com/v2/";

// export const API_BASE_URL = "https://hydapi.swachhcity.com/";

// new  production url

export const API_BASE_URL1 = "https://ghmchyd.swachhcity.com/oldswm/v1/";
export const API_BASE_URL3 = "https://ghmchyd.swachhcity.com/oldswm/v2/";

export const API_BASE_URL = "https://ghmchyd.swachhcity.com/oldswm/";


// export const API_BASE_URL1 = "https://swmp2devapi.vmaxtechservices.help/v1/";
// export const API_BASE_URL3 = "https://swmp2devapi.vmaxtechservices.help/v2/";

//  export const API_BASE_URL = "https://swmp2devapi.vmaxtechservices.help/"

// export const API_BASE_URL1 = "http://localhost:5250/v1/";
// export const API_BASE_URL3 = "http://localhost:5250/v2/";

//  export const API_BASE_URL = "http://localhost:5250/"

//export const googleMapsApiKey11 = "AIzaSyAmek9bF8SnmFeUH4BvEffHYu_TuUieoDw";

//GOOGLE MAP
export const googleMapsApiKey11 = "AIzaSyAmek9bF8SnmFeUH4BvEffHYu_TuUieoDw";
